import OidcService from "../services/oidc.service";
import { PluginObject } from "vue";

const pluginObject: PluginObject<{}> = {
  install(Vue) {
    Vue.prototype.$oidc = new OidcService();
  },
};

export default pluginObject;
